<template>
  <div v-if="estimate">
    <div class="header">
      <div v-if="hasEstimate" class="score">{{getEstimateScore(estimate.paperEstimates)}}</div>
      <div v-else class="no-score">暂无估分</div>
      <div class="header-desc">我的总分</div>
    </div>
    <div class="personal-info">
      <div class="rank">
        <div class="rank-place">{{hasEstimate ? estimate.rank : '— —'}}</div>
        <div class="info-name">全省排名</div>
      </div>
      <div class="line"></div>
      <div class="beat">
        <div class="rate">
          <span v-if="hasEstimate">{{(100*estimate.beatRate).toFixed(0)}}%</span>
          <span v-else>— —</span>
        </div>
        <div class="info-name">击败的考生</div>
      </div>
    </div>
    <div class="paper-list">
      <div class="paper-item" v-for="(paper, index) in estimate.paperEstimates" :key="index">
        <div class="paper-content">
          <span>{{paper.courseName}}
            <span class="paper-name" v-if="paper.categoryName">({{paper.categoryName}})</span>
          </span>
          <span class="paper-enter">
            <a v-if="paper.status===1" class="paper-done" @click="enterPaper(paper.paperId)">{{getPaperScore(paper)}}分</a>
            <span v-if="paper.status===0">
              <span v-if="paper.openingTime === 0" class="disabled">即将开始</span>
              <count-down v-else :deadline="paper.openingTime" :paperId="paper.paperId"></count-down>
            </span>
            <span class="icon-right"></span>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div v-else><Loading></Loading></div>
</template>

<script>
import CountDown from './CountDown'
import Loading from './Loading'
import apiService from '../services/api'
import estimateUtil from '../utils/estimate'
import queryParser from '../utils/query'
import WebView from '@solar/common-webview'
import ua from '../utils/ua'
// import Frog from '../../node_modules/@yuanfudao/frog'

const query = queryParser.parse()
const shareMap = {
  qq: '/click/evaluate2019/shareToQQ',
  qzone: '/click/evaluate2019/shareToQzone',
  wechat: '/click/evaluate2019/shareToWeixin',
  moments: '/click/evaluate2019/shareToMoments',
  weibo: '/click/evaluate2019/shareToWeibo'
}

export default {
  name: 'personal',
  components: { CountDown, Loading },
  props: ['majorId', 'quizId'],
  created () {
    // FIX: iOS设置分享按钮延时
    // setTimeout(() => {
    //   window.YTK_API.setRightButton({ hidden: true })
    //   window.YTK_API.setShareButton({ hidden: true })
    // }, 300)
    this.setShare()
    console.log('test')
    if (ua.isYuanSouTi()) {
      apiService.getSolarUser().then(res => {
        if (res.body.trial) {
          this.login()
          return false
        }
        this.userId = res.body.ytkUserId
        window.ytkUserId = res.body.ytkUserId
        window.solarUserId = res.body.userId
        return apiService.getEstimate(res.body.ytkUserId, this.majorId, this.quizId)
      }, err => {
        if (err.status === 401) {
          this.login()
        }
      }).then(res => {
        if (!res || !res.body) {
          return false
        }
        this.estimate = res.body
        this.paperEstimates = this.estimate.paperEstimates
        if (this.paperEstimates) {
          let hasEstimate = false
          this.paperEstimates.map(es => {
            if (es.status !== 0) {
              hasEstimate = true
              this.hasEstimate = hasEstimate
            }
          })
          let evaluate = this.hasEstimate ? 1 : 0
          this.$addFrog('/event/evaluate2019/enter', { evaluate: evaluate, courseid: this.estimate.majorId, provinceid: this.estimate.quizId })
        }
      })
    } else {
      apiService.getUser().then(res => {
        if (res.body.trial) {
          this.login()
          return false
        }
        this.userId = res.body.id
        window.ytkUserId = res.body.id
        return apiService.getEstimate(res.body.id, this.majorId, this.quizId)
      }, err => {
        if (err.status === 401) {
          this.login()
        }
      }).then(res => {
        if (!res || !res.body) {
          return false
        }
        this.estimate = res.body
        this.paperEstimates = this.estimate.paperEstimates
        if (this.paperEstimates) {
          let hasEstimate = false
          this.paperEstimates.map(es => {
            if (es.status !== 0) {
              hasEstimate = true
              this.hasEstimate = hasEstimate
            }
          })
        }
        let evaluate = this.hasEstimate ? 1 : 0
        this.$addFrog('/event/evaluate2019/enter', { evaluate: evaluate, courseid: this.estimate.majorId, provinceid: this.estimate.quizId })
      })
    }
  },
  mounted () {
  },
  data () {
    return {
      estimate: null,
      hasEstimate: false,
      userId: null,
      keyfrom: query.keyfrom,
      isGaosan: Number(query.isGaosan),
      wenanId: 255,
      appId: ua.getAppId(),
      fromStr: `${query.from ? '&from=' + query.from : ''}`,
      keyfromStr: `${query.keyfrom ? '&keyfrom=' + query.keyfrom : ''}`
    }
  },
  methods: {
    shareCallback (err, platform) {
      console.log(err, platform)
      this.$addFrog(shareMap[platform])
    },
    onShare () {
      this.$addFrog('/click/evaluate2019/share', { courseid: this.estimate.majorId, provinceid: this.estimate.quizId })
      WebView.showShareWindow({
        shareInfoUrl: `${location.protocol}//${location.host}/wenan/api/groups/${this.wenanId}`,
        trigger: this.shareCallback
      })
    },
    setShare () {
      WebView.setRightButton({
        hidden: true
      })
    },
    enterPaper (paperid) {
      console.log('paperid', paperid)
      const { hasEstimate } = this
      let evaluate = hasEstimate ? 1 : 0
      this.$addFrog('/click/evaluate2019/report', { evaluate: evaluate, paperid: paperid, courseid: this.estimate.majorId, provinceid: this.estimate.quizId })
      setTimeout(() => {
        window.location.href = `/h5/ape-web-homework_estimate/report.html?userId=${this.userId}&isGaosan=${this.isGaosan}&paperId=${paperid}${this.fromStr}${this.keyfromStr}`
      }, 100)
    },
    getEstimateScore (paperEstimates) {
      return estimateUtil.getEstimateScore(paperEstimates)
    },
    getPaperScore (paperEstimate) {
      return estimateUtil.getPaperScore(paperEstimate)
    },
    login () {
      if (/yuanfudao|yuantiku|yuansouti/i.test(navigator.userAgent)) {
        window.YTK_API.login({
          callback: function () {
            window.location.href = window.location.href
          }
        })
      } else {
        window.location.href = '/h5/ape-web-login/?redirect=' + window.location.href
      }
    }
  }
}
</script>
<style scoped>
.header {
  position: relative;
  height: 164px;
  background: #0097FF;
  color: #FFF;
  text-align: center;
}
.no-score {
  font-size: 40px;
  line-height: 154px;
}
.score {
  font-size: 70px;
  line-height: 154px;
}
.header-desc {
  position: absolute;
  bottom: 30px;
  width: 100%;
  text-align: center;
  font-size: 12px;
  line-height: 1;
}
.personal-info {
  position: relative;
  padding: 14px 10px 6px 10px;
  height:  60px;
  background: #FFF;
}
.rank {
  float: left;
  box-sizing: border-box;
  width: 50%;
  text-align: center;
}
.line {
  position: absolute;
  top: 24px;
  left: 50%;
  width: 1px;
  height: 30px;
  border-left: 1px solid #e7e7e7;
}
.beat {
  float: right;
  width: 50%;
  text-align: center;
}
.rank-place {
  color: #0099FF;
  font-size: 22px;
}
.rate {
  color: #FF5136;
  font-size: 22px;
}
.info-name {
  font-size: 12px;
  color: #666;
}
.paper-list {
  height: 100%;
  background: #FFF;
}
.paper-item {
  padding: 0 15px;
  height: 50px;
  line-height: 50px;
}
.paper-content {
  border-top: 1px solid #E7E7E7;
  color: #333;
}
.paper-name {
  padding-left: 3px;
  color: #666;
  font-size: 14px;
}
.paper-item:first-child .paper-content {
  border-top: none;
}
.paper-enter {
  float: right;
  font-size: 14px;
}
.disabled {
  color: #CCC;
}
.paper-enter .paper-done {
  color: #666;
}
.icon-right {
  display: inline-block;
  margin-left: 5px;
  width: 4px;
  height: 7px;
  background: url('//gallery.fbcontent.cn/api/ape/images/15c0a30f897416a.png') no-repeat;
  background-size: contain;
}

.paper-banner {
  margin: 10px 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Personal.vue?3965b6f9